<template>
  <BlokkliItem
    v-if="item"
    :key="item.uuid"
    v-bind="item"
    :index
    :data-reusable-bundle="item.bundle"
    :data-reusable-uuid="item.uuid"
    :data-bk-library-label="libraryItem?.label"
    :data-bk-library-item-uuid="libraryItem?.uuid"
    data-blokkli-is-reusable="true"
    :parent-type
    :is-editing
  />
</template>

<script setup>
import { computed, provide, defineBlokkli } from "#imports";
import {
  INJECT_IS_IN_REUSABLE,
  INJECT_REUSABLE_OPTIONS
} from "#blokkli/helpers/symbols";
const props = defineProps({
  libraryItem: { type: Object, required: false }
});
const { index, options, parentType, isEditing } = defineBlokkli({
  bundle: "from_library"
});
provide(INJECT_REUSABLE_OPTIONS, options);
provide(INJECT_IS_IN_REUSABLE, true);
const item = computed(() => {
  const v = props.libraryItem?.block;
  if (v && "uuid" in v) {
    return v;
  }
  return void 0;
});
</script>

<script>
export default {
  name: "BlokkliFromLibrary"
};
</script>
